import { openDB, type IDBPDatabase } from 'idb';

const DB_NAME = 'relocation-map';
const DB_VERSION = 1;

type CacheStore = 'keyval';

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('keyval')) {
          db.createObjectStore('keyval');
        }
      },
    });
  }
  return dbPromise;
}

export async function cacheGet<T>(key: string): Promise<T | undefined> {
  try {
    const db = await getDb();
    return db.get('keyval' as CacheStore, key);
  } catch {
    return undefined;
  }
}

export async function cachePut<T>(key: string, value: T): Promise<void> {
  try {
    const db = await getDb();
    await db.put('keyval' as CacheStore, value, key);
  } catch {
    // IDB unavailable (private mode etc.) — silent
  }
}

export async function cacheClear(): Promise<void> {
  try {
    const db = await getDb();
    await db.clear('keyval' as CacheStore);
  } catch {
    // ignore
  }
}

// Удаляет ключи, не подходящие под предикат. Используется для версионной инвалидации:
// при boot meta.version != cached → стираем всё что не относится к текущей версии.
export async function cacheSweep(keep: (key: string) => boolean): Promise<void> {
  try {
    const db = await getDb();
    const allKeys = await db.getAllKeys('keyval' as CacheStore);
    for (const k of allKeys) {
      if (typeof k === 'string' && !keep(k)) {
        await db.delete('keyval' as CacheStore, k);
      }
    }
  } catch {
    // ignore
  }
}
